import { createContext, useContext } from "react";

/** rc-trigger passes the trigger's DOM node; the getter may use it to find its surface. */
export type KuikaPopupContainerGetter = (triggerNode?: HTMLElement) => HTMLElement;

/**
 * Where the kit's rc-trigger popups (KuikaSelectbox, KuikaDropdownMenu) mount their menus.
 *
 * rc-trigger portals to `document.body` by default. That is fine everywhere except inside a
 * modal surface that blocks the page behind it: KuikaDrawer's Radix Dialog sets
 * `pointer-events: none` on `<body>`, so a menu portaled there is painted but cannot be
 * clicked. Such a surface provides its own element here, and every kit popup rendered inside
 * it mounts there instead — no call-site prop to remember.
 *
 * Outside a provider the value is undefined and the popups keep rc-trigger's default. An
 * explicit `getPopupContainer` prop on the popup always wins over this context.
 */
export const KuikaPopupContainerContext = createContext<KuikaPopupContainerGetter | undefined>(undefined);

export const useKuikaPopupContainer = (): KuikaPopupContainerGetter | undefined =>
  useContext(KuikaPopupContainerContext);
